const messageLogicOperators = {
  NEWER_THAN: 'newer_than',
  NEWER_THAN_OR_EQUAL: 'newer_than_or_equal',
  OLDER_THAN: 'older_than',
  OLDER_THAN_OR_EQUAL: 'older_than_or_equal',
}

export default messageLogicOperators
